import { SupportWidget } from "hooks/useSupportWidget";


export function useChatbase(): SupportWidget {
  return {
    showSupportForm: () => { window.chatbase?.open(); },
    hideSupportForm: () => { window.chatbase?.close(); },
    showSalesForm: () => {}
  };
}
